import { Skeleton } from '@app/components/various/Skeleton';
import cx from 'classnames';

interface Props {
  isMultiLine?: boolean;
  isRightAligned?: boolean;
}

export const TextSkeleton = ({ isMultiLine, isRightAligned }: Props) => {
  const textProps = isMultiLine ? { lastWidth: 80, rows: 2 } : {};

  return <Skeleton type="text" gap="small" {...textProps} size="medium" containerClassName={cx({ 'items-end': isRightAligned })} />;
};
